// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * This is a custom input style scoped specifically to LegacyCinePlayer
 * written in plain CSS with color variables from tailwind
 * to avoid complex compatibility configuration.
 */
.LegacyCinePlayer input[type='range'] {
  -webkit-appearance: none;
  background: transparent;
  width: 100%;
  height: 20px;
  z-index: 5;
}
.LegacyCinePlayer input[type='range']:focus {
  outline: none;
}
.LegacyCinePlayer input[type='range']::-webkit-slider-runnable-track {
  width: 100%;
  height: 2px;
  cursor: pointer;
  animate: 0.2s;
  -webkit-box-shadow: 0px 0px 0px #000000;
          box-shadow: 0px 0px 0px #000000;
  --tw-bg-opacity: 1;
  background-color: rgba(90, 204, 230, var(--tw-bg-opacity));
  border-radius: 5px;
  border: 0px solid #000000;
}
.LegacyCinePlayer input[type='range']::-webkit-slider-thumb {
  -webkit-box-shadow: 0px 0px 0px #000000;
          box-shadow: 0px 0px 0px #000000;
  border: 4px solid #000000;
  height: 18px;
  width: 17px;
  border-radius: 50px;
  --tw-bg-opacity: 1;
  background-color: rgba(90, 204, 230, var(--tw-bg-opacity));
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -9px;
}
.LegacyCinePlayer input[type='range']:focus::-webkit-slider-runnable-track {
  --tw-bg-opacity: 1;
  background-color: rgba(90, 204, 230, var(--tw-bg-opacity));
}
.LegacyCinePlayer input[type='range']::-moz-range-track {
  width: 100%;
  height: 2px;
  cursor: pointer;
  animate: 0.2s;
  box-shadow: 0px 0px 0px #000000;
  --tw-bg-opacity: 1;
  background-color: rgba(90, 204, 230, var(--tw-bg-opacity));
  border-radius: 5px;
  border: 0px solid #000000;
}
.LegacyCinePlayer input[type='range']::-moz-range-thumb {
  box-shadow: 0px 0px 0px #000000;
  border: 2px solid #000000;
  height: 12px;
  width: 12px;
  border-radius: 50px;
  --tw-bg-opacity: 1;
  background-color: rgba(90, 204, 230, var(--tw-bg-opacity));
  cursor: pointer;
}
.LegacyCinePlayer input[type='range']::-ms-track {
  width: 100%;
  height: 2px;
  cursor: pointer;
  animate: 0.2s;
  background: transparent;
  border-color: transparent;
  color: transparent;
}
.LegacyCinePlayer input[type='range']::-ms-fill-lower {
  --tw-bg-opacity: 1;
  background-color: rgba(90, 204, 230, var(--tw-bg-opacity));
  border: 0px solid #000000;
  border-radius: 10px;
  box-shadow: 0px 0px 0px #000000;
}
.LegacyCinePlayer input[type='range']::-ms-fill-upper {
  --tw-bg-opacity: 1;
  background-color: rgba(90, 204, 230, var(--tw-bg-opacity));
  border: 0px solid #000000;
  border-radius: 10px;
  box-shadow: 0px 0px 0px #000000;
}
.LegacyCinePlayer input[type='range']::-ms-thumb {
  margin-top: 1px;
  box-shadow: 0px 0px 0px #000000;
  border: 4px solid #000000;
  height: 18px;
  width: 17px;
  border-radius: 50px;
  --tw-bg-opacity: 1;
  background-color: rgba(90, 204, 230, var(--tw-bg-opacity));
  cursor: pointer;
}
.LegacyCinePlayer input[type='range']:focus::-ms-fill-lower {
  --tw-bg-opacity: 1;
  background-color: rgba(90, 204, 230, var(--tw-bg-opacity));
}
.LegacyCinePlayer input[type='range']:focus::-ms-fill-upper {
  --tw-bg-opacity: 1;
  background-color: rgba(90, 204, 230, var(--tw-bg-opacity));
}
`, "",{"version":3,"sources":["webpack://./../../ui/src/components/LegacyCinePlayer/LegacyCinePlayerCustomInputRange.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;EACE,wBAAwB;EACxB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;AAEA;EACE,aAAa;AACf;AAEA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf,aAAa;EACb,uCAA+B;UAA/B,+BAA+B;EAC/B,kBAAuB;EAAvB,0DAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;AAEA;EACE,uCAA+B;UAA/B,+BAA+B;EAC/B,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kBAAuB;EAAvB,0DAAuB;EACvB,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;AAGE;EAAA,kBAAuB;EAAvB;AAAuB;AAGzB;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf,aAAa;EACb,+BAA+B;EAC/B,kBAAuB;EAAvB,0DAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kBAAuB;EAAvB,0DAAuB;EACvB,eAAe;AACjB;AAEA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;AAGE;EAAA,kBAAuB;EAAvB,0DAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB;AAHuB;AAOvB;EAAA,kBAAuB;EAAvB,0DAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB;AAHuB;AAMzB;EACE,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kBAAuB;EAAvB,0DAAuB;EACvB,eAAe;AACjB;AAGE;EAAA,kBAAuB;EAAvB;AAAuB;AAIvB;EAAA,kBAAuB;EAAvB;AAAuB","sourcesContent":["/*\n * This is a custom input style scoped specifically to LegacyCinePlayer\n * written in plain CSS with color variables from tailwind\n * to avoid complex compatibility configuration.\n */\n.LegacyCinePlayer input[type='range'] {\n  -webkit-appearance: none;\n  background: transparent;\n  width: 100%;\n  height: 20px;\n  z-index: 5;\n}\n\n.LegacyCinePlayer input[type='range']:focus {\n  outline: none;\n}\n\n.LegacyCinePlayer input[type='range']::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 2px;\n  cursor: pointer;\n  animate: 0.2s;\n  box-shadow: 0px 0px 0px #000000;\n  @apply bg-primary-light;\n  border-radius: 5px;\n  border: 0px solid #000000;\n}\n\n.LegacyCinePlayer input[type='range']::-webkit-slider-thumb {\n  box-shadow: 0px 0px 0px #000000;\n  border: 4px solid #000000;\n  height: 18px;\n  width: 17px;\n  border-radius: 50px;\n  @apply bg-primary-light;\n  cursor: pointer;\n  -webkit-appearance: none;\n  margin-top: -9px;\n}\n\n.LegacyCinePlayer input[type='range']:focus::-webkit-slider-runnable-track {\n  @apply bg-primary-light;\n}\n\n.LegacyCinePlayer input[type='range']::-moz-range-track {\n  width: 100%;\n  height: 2px;\n  cursor: pointer;\n  animate: 0.2s;\n  box-shadow: 0px 0px 0px #000000;\n  @apply bg-primary-light;\n  border-radius: 5px;\n  border: 0px solid #000000;\n}\n\n.LegacyCinePlayer input[type='range']::-moz-range-thumb {\n  box-shadow: 0px 0px 0px #000000;\n  border: 2px solid #000000;\n  height: 12px;\n  width: 12px;\n  border-radius: 50px;\n  @apply bg-primary-light;\n  cursor: pointer;\n}\n\n.LegacyCinePlayer input[type='range']::-ms-track {\n  width: 100%;\n  height: 2px;\n  cursor: pointer;\n  animate: 0.2s;\n  background: transparent;\n  border-color: transparent;\n  color: transparent;\n}\n\n.LegacyCinePlayer input[type='range']::-ms-fill-lower {\n  @apply bg-primary-light;\n  border: 0px solid #000000;\n  border-radius: 10px;\n  box-shadow: 0px 0px 0px #000000;\n}\n\n.LegacyCinePlayer input[type='range']::-ms-fill-upper {\n  @apply bg-primary-light;\n  border: 0px solid #000000;\n  border-radius: 10px;\n  box-shadow: 0px 0px 0px #000000;\n}\n\n.LegacyCinePlayer input[type='range']::-ms-thumb {\n  margin-top: 1px;\n  box-shadow: 0px 0px 0px #000000;\n  border: 4px solid #000000;\n  height: 18px;\n  width: 17px;\n  border-radius: 50px;\n  @apply bg-primary-light;\n  cursor: pointer;\n}\n\n.LegacyCinePlayer input[type='range']:focus::-ms-fill-lower {\n  @apply bg-primary-light;\n}\n\n.LegacyCinePlayer input[type='range']:focus::-ms-fill-upper {\n  @apply bg-primary-light;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
